// Helpers de formatage date/heure Europe/Paris pour toute l'app.
// Le backend renvoie des datetimes UTC parfois sans suffixe 'Z' ; on l'ajoute
// avant `new Date(...)` pour éviter que le navigateur parse en heure locale.

const _DT_FR = new Intl.DateTimeFormat("fr-FR", {
  dateStyle: "short",
  timeStyle: "medium",
  timeZone: "Europe/Paris",
});

const _D_FR = new Intl.DateTimeFormat("fr-FR", {
  dateStyle: "short",
  timeZone: "Europe/Paris",
});

const _T_FR = new Intl.DateTimeFormat("fr-FR", {
  timeStyle: "short",
  timeZone: "Europe/Paris",
});

export function toDate(v) {
  if (!v) return null;
  if (v instanceof Date) return v;
  if (typeof v === "string") {
    const iso = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/.test(v);
    const hasTz = /[Zz]$|[+-]\d{2}:?\d{2}$/.test(v);
    if (iso && !hasTz) return new Date(v.replace(" ", "T") + "Z");
  }
  return new Date(v);
}

export const fmtDateTime = (v) => {
  const d = toDate(v);
  return d ? _DT_FR.format(d) : "";
};

export const fmtDate = (v) => {
  const d = toDate(v);
  return d ? _D_FR.format(d) : "";
};

export const fmtTime = (v) => {
  const d = toDate(v);
  return d ? _T_FR.format(d) : "";
};
